import * as React from "react";
import AlertContext from "components/providers/Alert";

const useAlert = () => React.useContext(AlertContext);

export default useAlert;
